import reveal from './reveal'
import track from './track'

export default {
  reveal,
  track
}
